// removed by extract-text-webpack-plugin
module.exports = {"backgroundLight":"IconBannedUser__backgroundLight__1htPu","backgroundDark":"IconBannedUser__backgroundDark__mkbEL","foregroundFill":"IconBannedUser__foregroundFill__1NCJo","foregroundStroke":"IconBannedUser__foregroundStroke__1vUbt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/IconBannedUser/IconBannedUser.css
// module id = 1828
// module chunks = 0